import './styles.scss'
import React from 'react'

const LabelButton = ({ label, text, imageUrl, imageClear, onClick, onClickClear , isDisabled, className='', isClear=false }) => (
  <div className={`label-button ${isDisabled ? 'label-button--disabled' : ''} ${className !== '' ? className : ''}`} onClick={!isDisabled ? onClick : null}>
    <div className="label-button__content">
      <span>{label}</span>
      <strong>{text}</strong>
    </div>
    {isClear &&
      <figure className="label-button__image clear-styles" onClick={onClickClear} >
        <img src={imageClear} alt={label}/>
      </figure>
    }
    <figure className="label-button__image">
      <img src={imageUrl} alt={label} />
    </figure> 
  </div>
)

export default LabelButton
